import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';
import { CoordinateSystemsMockService } from '@mock/data-services/coordinate-systems-mock.service';

@Injectable({
  providedIn: 'root',
})
export class CoordinateSystemsApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly MOCK: CoordinateSystemsMockService
  ) {}

  public getAll(): Observable<IApiResponse<ICoordinateSystem[], object>> {
    if (this.MOCK.isMockEnabled()) return this.MOCK.getAll();

    const url = `${environment.apiBaseUrl}/v1/coordinate-systems`;

    return this.httpClient.get<IApiResponse<ICoordinateSystem[], object>>(url, {
      withCredentials: true,
    });
  }
}
